<template>
  <div
    class="common-box"
    :class="$store.state.isLandscape ? 'shuiping' : 'chuizhi'"
    :style="{ backgroundColor: $store.state.isLandscape ? '#f8f8f8' : '' }"
  >
    <!-- <button ref="play" @click="startplay" v-show="false">播放</button>
    <button ref="stop" @click="pausePlay" v-show="false">暂停</button> -->
    <div class="common-title">血糖曲线</div>
    <div class="handleShow" @click="$store.state.isLandscape ? outFull() : inFull()">
      <!-- <div class="handleShow" @click="changeLand()"> -->
      <img
        :src="$store.state.isLandscape ? require('../../static/pic/nofull.png') : require('../../static/pic/full.png')"
      />
    </div>
    <div id="container1" ref="container1" style="width: 100%" :style="{ height: chartHeight + 'px' }"></div>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import {
    getSugerbyId,
    loopTreatments,
    getAllTempArry,
    getEvent,
    getDeviceData,
    getAolXueyaData,
    getAolXuetangData,
    getPenInfo,
  } from '@/api/userServices'
  import { Mix, G2 } from '@antv/g2plot'
  import yds from '@/static/pic/loopYDS.png'
  import { loopHistory } from '@/api/relationship'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import {
    DEFAULT_INSULIN_AGE_MODE,
    getInsulinEffectDurationHours,
    getInsulinTypeName,
    getLatestInsulinEffectEndTimestamp,
    getRecordInsulinEffectDurationHours,
    percentEffectRemainingForRecord,
  } from '@/utils/loopInsulinModel'
  const G = G2.getEngine('canvas')
  export default {
    props: {
      btnNum: {
        default: '',
      },
      isIndex: {
        default: '',
      },
      isAlarm: {
        default: '',
      },
      selectedDate: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tickInterval: 30 * 60 * 1000,
        bottomNum: '',
        timer: null, // 5分钟一次的定时器
        timerNum: 0,
        mixPlot1: null,
        chartData: [],
        userId: JSON.parse(localStorage.getItem('appuser')).id,
        chartTime: 0.875,
        trend: '',
        sliderEnd: 1,
        sliderStart: 0,
        isDown: false,
        startX: '',
        endX: '',
        moveX: '',
        boxWidth: '',
        moveRate: '',
        downLeft: '',
        downRight: '',
        isHaveSugar: true,
        targetHigh: '',
        targetLow: '',
        allTempArray: [], // 基础率组合数组
        loopRemote: JSON.parse(localStorage.getItem('appuser')).loopRemote,
        chartHeight: '',
        // 下面是socket相关参数
        socketId: JSON.parse(localStorage.getItem('appuser')).id,
        isToday: true,
        maxTemp: 1.6,
        insRecordList: [],
        actIobList: [],
        maxIob: 0,
        insType: '',
        insulinAgeMode: DEFAULT_INSULIN_AGE_MODE,
        duration: getInsulinEffectDurationHours(),
        targetHigh: '',
        targetLow: '',
      }
    },
    created() {
      this.targetHigh = JSON.parse(localStorage.getItem('appuser')).targetHigh || '10'
      this.targetLow = JSON.parse(localStorage.getItem('appuser')).targetLow || '3.9'
    },
    mounted() {
      this.getData().then(() => {
        this.getAllEvent().then(() => {
          this.getChart()
        })
      })

      this.chartHeight = this.$store.state.isLandscape ? window.innerWidth - 40 : 310
    },
    beforeDestroy() {
      if (this.mixPlot1) {
        this.mixPlot1.destroy()
        this.mixPlot1 = null // 清空图表实例
      }
      clearInterval(this.timer) // 停止定时1
      if (this.mixPlot1) {
        this.mixPlot1.destroy()
        this.mixPlot1 = null // 清空图表实例
      }
    },
    methods: {
      // 根据选择的日期，截取当天的设备数据
      filterDataByDate(dataArr, targetDate) {
        // 1. 校验入参
        if (!Array.isArray(dataArr) || !targetDate) {
          console.warn('入参不合法，请传入数组和有效日期')
          return []
        }

        // 2. 将目标日期转为当天0点和24点的时间戳（秒级）
        const targetStartTimestamp = new Date(`${targetDate} 00:00:00`).getTime() / 1000
        const targetEndTimestamp = new Date(`${targetDate} 23:59:59`).getTime() / 1000

        // 3. 筛选数据：判断数据中的time是否在当天时间戳范围内
        return dataArr.filter(item => {
          // 校验数据格式，避免报错
          if (!item?.content?.time) return false

          // 转为数字类型进行比较
          const dataTimestamp = Number(item.content.time)
          return dataTimestamp >= targetStartTimestamp && dataTimestamp <= targetEndTimestamp
        })
      },
      getAolDataList(res) {
        const data = res && res.data ? res.data.data : []
        return Array.isArray(data) ? data : []
      },
      safeJsonParse(value) {
        if (!value || typeof value !== 'string') return value
        try {
          return JSON.parse(value)
        } catch (e) {
          return value
        }
      },
      mergeDefinedFields(...sources) {
        return sources.reduce((result, current) => {
          if (!current || typeof current !== 'object') return result
          Object.keys(current).forEach(key => {
            const value = current[key]
            if (value !== undefined && value !== null && value !== '') {
              result[key] = value
            }
          })
          return result
        }, {})
      },
      getAolContent(item) {
        return item.content || item.data || item
      },
      getAolTimeMs(item) {
        const content = this.getAolContent(item)
        const time =
          content.time ||
          content.create_time ||
          content.createTime ||
          content.timestamp ||
          content.measure_time ||
          content.measureTime ||
          content.test_time ||
          content.testTime ||
          item.create_time ||
          item.createTime
        if (!time) return null

        if (typeof time === 'number' || /^\d+$/.test(time)) {
          const timeNum = Number(time)
          return timeNum < 1000000000000 ? timeNum * 1000 : timeNum
        }

        const timeMs = new Date(String(time).replace(/-/g, '/')).getTime()
        return isNaN(timeMs) ? null : timeMs
      },
      normalizeTimestamp(value) {
        if (!value) return 0
        if (typeof value === 'number') {
          return value > 9999999999 ? value : value * 1000
        }
        if (/^\d+$/.test(String(value))) {
          const num = Number(value)
          return num > 9999999999 ? num : num * 1000
        }
        const parsed = new Date(String(value).replace(/-/g, '/')).getTime()
        return Number.isNaN(parsed) ? 0 : parsed
      },
      normalizeAolXueyaItem(item) {
        const source = item && typeof item === 'object' ? item : {}
        const parsedData = this.safeJsonParse(source.data)
        const parsedContent = this.safeJsonParse(source.content)
        const parsedJson = this.safeJsonParse(source.json)
        return {
          ...source,
          ...(parsedData && typeof parsedData === 'object' ? parsedData : {}),
          ...(parsedContent && typeof parsedContent === 'object' ? parsedContent : {}),
          ...(parsedJson && typeof parsedJson === 'object' ? parsedJson : {}),
        }
      },
      normalizeAolXuetangItem(item) {
        const source = item && typeof item === 'object' ? item : {}
        const parsedData = this.safeJsonParse(source.data)
        const parsedContent = this.safeJsonParse(source.content)
        const parsedJson = this.safeJsonParse(source.json)
        return {
          ...source,
          ...(parsedData && typeof parsedData === 'object' ? parsedData : {}),
          ...(parsedContent && typeof parsedContent === 'object' ? parsedContent : {}),
          ...(parsedJson && typeof parsedJson === 'object' ? parsedJson : {}),
        }
      },
      isSameSelectedDateByTime(value) {
        const timeMs = this.normalizeTimestamp(value)
        if (!timeMs || !this.selectedDate) return false
        return this.$moment(timeMs).format('YYYY-MM-DD') === this.selectedDate
      },
      formatAolXueyaChartData(list) {
        const today = this.$moment().format('YYYY-MM-DD')
        return (list || [])
          .filter(item => this.isSameSelectedDateByTime(item && item.time))
          .map(item => {
            const timeMs = this.normalizeTimestamp(item.time)
            const normalizedItem = this.normalizeAolXueyaItem(item)
            const displayTime = this.$moment(timeMs).format('HH:mm:ss')
            return {
              create_time: today + ' ' + displayTime,
              tooltip_time: displayTime.substring(0, 5),
              type: 'aolXy',
              v: 17,
              data1: normalizedItem.data1,
              data2: normalizedItem.data2,
              data3: normalizedItem.data3,
            }
          })
      },
      formatAolXuetangChartData(list) {
        const today = this.$moment().format('YYYY-MM-DD')
        return (list || [])
          .filter(item => this.isSameSelectedDateByTime(item && item.time))
          .map(item => {
            const timeMs = this.normalizeTimestamp(item.time)
            const normalizedItem = this.normalizeAolXuetangItem(item)
            const displayTime = this.$moment(timeMs).format('HH:mm:ss')
            const value = Number(normalizedItem.data3) / 18
            return {
              create_time: today + ' ' + displayTime,
              tooltip_time: displayTime.substring(0, 5),
              type: 'aolXt',
              v: 19,
              value: Number.isFinite(value) ? Number(value.toFixed(1)) : '--',
            }
          })
      },
      filterAolDataByDate(dataArr, targetDate) {
        if (!Array.isArray(dataArr) || !targetDate) return []

        const targetStartTimestamp = new Date(`${targetDate} 00:00:00`).getTime()
        const targetEndTimestamp = new Date(`${targetDate} 23:59:59`).getTime()

        return dataArr.filter(item => {
          const timeMs = this.getAolTimeMs(item)
          return timeMs && timeMs >= targetStartTimestamp && timeMs <= targetEndTimestamp
        })
      },
      createAolSugarPoint(item, datePrefix) {
        const timeMs = this.getAolTimeMs(item)
        if (!timeMs) return null
        const content = this.normalizeAolXuetangItem(item)
        const value = Number(content.data3) / 18
        return {
          create_time: datePrefix
            ? `${datePrefix} ${this.$moment(timeMs).format('HH:mm:ss')}`
            : this.$moment(timeMs).format('YYYY-MM-DD HH:mm:ss'),
          tooltip_time: this.$moment(timeMs).format('HH:mm'),
          type: 'aolXt',
          v: 19,
          value: Number.isFinite(value) ? Number(value.toFixed(1)) : '--',
        }
      },
      createAolBloodPressurePoint(item, datePrefix) {
        const timeMs = this.getAolTimeMs(item)
        if (!timeMs) return null
        const content = this.normalizeAolXueyaItem(item)
        return {
          create_time: datePrefix
            ? `${datePrefix} ${this.$moment(timeMs).format('HH:mm:ss')}`
            : this.$moment(timeMs).format('YYYY-MM-DD HH:mm:ss'),
          tooltip_time: this.$moment(timeMs).format('HH:mm'),
          type: 'aolXy',
          v: 17,
          data1: content.data1,
          data2: content.data2,
          data3: content.data3,
        }
      },
      addAolDeviceData(datePrefix) {
        return Promise.all([getAolXuetangData({ uid: this.userId }), getAolXueyaData({ uid: this.userId })])
          .then(([sugarRes, bloodPressureRes]) => {
            this.formatAolXuetangChartData(this.getAolDataList(sugarRes)).forEach(item => {
              this.chartData.push(item)
            })
            this.formatAolXueyaChartData(this.getAolDataList(bloodPressureRes)).forEach(item => {
              this.chartData.push(item)
            })
          })
          .catch(() => {
            return []
          })
      },
      getDateArray(time) {
        this.bottomNum = time
      },
      startplay() {
        // const audio = this.$refs.audio
        this.$refs.audio.play()

        setTimeout(() => {
          this.pausePlay()
        }, 10000)
        // audio.addEventListener('timeupdate', () => {
        //   if (audio.currentTime >= 10) {
        //     this.pausePlay() // 播放到10秒时暂停音频
        //     audio.currentTime = 0 // 可选：重置到音频开头
        //     console.log('音频播放了10秒钟，已停止')
        //   }
        // })
      },
      pausePlay() {
        //暂停播放
        this.$refs.audio.pause() //暂停
        // clearInterval(this.timer)
        // this.timer = null
      },
      // 格式化时间
      formatTime(timestamp) {
        const date = new Date(timestamp)
        return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss') // 返回 'YYYY-MM-DDTHH:mm:ss' 格式
      },
      // 获取当前时间时间戳
      parseTime(time) {
        return new Date(time).getTime()
      },
      // 20秒内如果胰岛素相同，则去重
      getTooltipTypeName(item) {
        let loopType = ''
        try {
          loopType = item && item.json ? JSON.parse(item.json).type : ''
        } catch (e) {}
        const loopMap = {
          1: '\u5173\u95ed\u95ed\u73af',
          2: '\u5f00\u542f\u95ed\u73af',
          3: '\u8986\u76d6\u65b9\u6ce2',
          4: '\u53d6\u6d88\u65b9\u6ce2',
          5: '\u6dfb\u52a0\u78b3\u6c34',
          6: '\u5927\u5242\u91cf',
          7: '\u4e34\u65f6\u57fa\u7840\u7387',
          8: '\u53d6\u6d88\u4e34\u65f6',
        }
        const typeMap = {
          sugar: '\u8840\u7cd6',
          zx: '\u6307\u5c16\u8840',
          kfy: '\u53e3\u670d\u836f',
          xy: '\u8840\u538b',
          aolXy: '\u7231\u5965\u4e50\u8840\u538b',
          xz: '\u8840\u8102',
          BF: '\u8840\u8102',
          ns: '\u5c3f\u9178',
          UA: '\u5c3f\u9178',
          aolXt: '\u7231\u5965\u4e50\u8840\u7cd6',
          GLU: '\u8840\u7cd6',
          KET: '\u8840\u916e',
          ts: '\u78b3\u6c34',
          yds: '\u80f0\u5c9b\u7d20',
          yd: '\u8fd0\u52a8',
          'Correction Bolus': '\u80f0\u5c9b\u7d20',
          'Meal Bolus': '\u80f0\u5c9b\u7d20',
          'Combo Bolus': '\u6269\u5c55\u80f0\u5c9b\u7d20',
          'Carb Correction': '\u78b3\u6c34',
          'Temporary Override': '\u8986\u76d6\u65b9\u6ce2',
          'Temporary Target': '\u8986\u76d6\u65b9\u6ce2',
          'Suspend Pump': '\u6cf5',
          'OpenAPS Offline': '\u6cf5',
        }
        return loopMap[loopType] || typeMap[item && item.type] || typeMap[item && item.eventType] || '\u5176\u4ed6'
      },
      renderPointTooltip(title, data) {
        const item = data && data[0] && data[0].data
        if (!title || !item) return ''
        const time = item.tooltip_time || (item.create_time ? this.$moment(item.create_time).format('HH:mm:ss') : title)
        const type = this.getTooltipTypeName(item)
        if (item.type === 'sugar') {
          const tempValue = item.tempValue ? item.tempValue.toFixed(2) : item.tempValue == 0 ? 0 : '\u65e0'
          const iob = item.iob ? (item.iob <= 0.04 ? 0 : item.iob) : 0
          return `<div style="padding:2px;">
                        <div style="margin-bottom:2px;font-size:10px;font-weight: 700;"> ${time}</div>
                        <div style="font-size:10px;margin-bottom:2px;">${type}:${(item.v * 1).toFixed(1)}</div>
                        <div style="margin-bottom:2px;font-size:10px"> \u57fa\u7840\u7387:${tempValue}</div>
                        <div style="font-size:10px;margin-bottom:2px;">\u6d3b\u6027\u80f0\u5c9b\u7d20:${iob}</div>
                      </div>`
        }
        const hasValue = value => value !== undefined && value !== null && String(value).trim() !== '' && value !== '--'
        const detailRow = text => `<div style="margin-bottom:4px;font-size:14px;">${text}</div>`
        if (['zx', 'kfy', 'xy', 'xz', 'ns', 'ts', 'yds', 'yd'].includes(item.type)) {
          let details = []
          switch (item.type) {
            case 'zx':
              details = [hasValue(item.eventValue) ? detailRow(`场景：${item.eventValue}`) : '', detailRow(`指血指数：${item.way}mmol/L`)]
              break
            case 'kfy':
              details = [detailRow(`药名：${item.way}`), hasValue(item.eventValue) ? detailRow(`用药量：${item.eventValue}mg`) : '']
              break
            case 'xy':
              details = [
                detailRow(`收缩压：${item.way}mmHg`),
                detailRow(`舒张压：${item.eventValue}mmHg`),
                hasValue(item.scene) ? detailRow(`心率：${item.scene}次/分`) : '',
              ]
              break
            case 'xz':
              details = [
                detailRow(`总胆固醇：${item.way}mmol/L`),
                detailRow(`甘油三酯：${item.eventValue}mmol/L`),
                hasValue(item.scene) ? detailRow(`低密度脂蛋白：${item.scene}mmol/L`) : '',
              ]
              break
            case 'ns':
              details = [detailRow(`尿酸值：${item.way}umol/L`)]
              break
            case 'ts':
              details = [detailRow(`${item.eventValue}`), detailRow(`碳水化合物：${item.way}g`)]
              break
            case 'yds':
              details = [
                detailRow(`注射剂量：${item.way}U`),
                hasValue(item.scene) ? detailRow(`注射时段：${item.scene}`) : '',
                hasValue(item.eventValue) ? detailRow(`胰岛素名称：${item.eventValue}`) : '',
              ]
              break
            case 'yd':
              details = [
                detailRow(`运动项目：${item.way}`),
                hasValue(item.scene) ? detailRow(`运动时长：${item.scene}分钟`) : '',
                hasValue(item.eventValue) ? detailRow(`消耗：${item.eventValue}kcal`) : '',
              ]
              break
          }
          return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight:700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;font-size:14px;">${time}</div>
                        ${details.join('')}
                      </div>`
        }
        if (item.type === 'Correction Bolus') {
          const insulin = item.insulin ? (item.insulin * 1).toFixed(2) : '\u65e0'
          return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${time}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> \u5242\u91cf:${insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> \u540d\u79f0:${
                          item.insulinType || '\u65e0'
                        }</div>
                      </div>`
        }
        if (item.type === 'Combo Bolus') {
          const insulin = item.insulin ? (item.insulin * 1).toFixed(2) : '\u65e0'
          return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${time}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> \u5242\u91cf:${insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> \u6301\u7eed\u65f6\u95f4:${
                          item.duration || '\u65e0'
                        }\u5206\u949f</div>
                      </div>`
        }
        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div> ${time}</div>
                      </div>`
      },
      sortInsRecordList() {
        this.insRecordList.sort((a, b) => this.$moment(a.createTime).valueOf() - this.$moment(b.createTime).valueOf())
      },
      iobFraction(t, item) {
        return percentEffectRemainingForRecord(t * 60, item, this.insType, this.insulinAgeMode)
      },
      getIOBChartData() {
        const intervalMinutes = 5
        const result = []
        const dayStart = this.$moment(`${this.selectedDate} 00:00:00`)
        const dayEnd = this.$moment(`${this.selectedDate} 23:59:59`)
        this.insRecordList = this.insRecordList.filter(item => {
          const injectionTime = this.$moment(item.createTime)
          const recordDuration = getRecordInsulinEffectDurationHours(item, this.insType, this.insulinAgeMode)
          const effectEnd = injectionTime.clone().add(recordDuration, 'hour')
          return injectionTime.isSameOrBefore(dayEnd) && effectEnd.isSameOrAfter(dayStart)
        })
        if (!this.insRecordList.length) return result
        const start = this.$moment(
          Math.max(dayStart.valueOf(), this.$moment(this.insRecordList[0].createTime).valueOf())
        )
        const latestEffectEnd = getLatestInsulinEffectEndTimestamp(
          this.insRecordList,
          this.insType,
          this.insulinAgeMode
        )
        const end = this.$moment(Math.min(dayEnd.valueOf(), latestEffectEnd))
        for (let time = start.clone(); time.isSameOrBefore(end); time.add(intervalMinutes, 'minutes')) {
          if (time.isAfter(dayEnd)) continue
          let total = 0
          this.insRecordList.forEach(item => {
            const dose = Number(item.realInsulin)
            const injTime = this.$moment(item.createTime)
            const deltaHours = time.diff(injTime, 'minutes') / 60
            const recordDuration = getRecordInsulinEffectDurationHours(item, this.insType, this.insulinAgeMode)
            if (Number.isFinite(dose) && deltaHours >= 0 && deltaHours <= recordDuration) {
              total += dose * this.iobFraction(deltaHours, item)
            }
          })
          const value = Number(total.toFixed(2))
          if (!value) continue
          result.push({
            create_time: time.format('YYYY-MM-DD HH:mm:ss'),
            tooltip_time: time.format('HH:mm'),
            value,
            type: 'iob',
          })
        }
        return result
      },
      fillChartDataIob() {
        if (!this.actIobList.length) return

        this.chartData.forEach(item => {
          if (!item || !item.create_time) return

          const time = this.$moment(item.create_time).valueOf()
          this.actIobList.forEach((iob, i) => {
            const preTime = this.$moment(iob.create_time).valueOf()
            const nextTime = this.actIobList[i + 1] ? this.$moment(this.actIobList[i + 1].create_time).valueOf() : null
            if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
              item.iob = iob.value
              item.iobType = iob.type
            }
          })
        })
      },
      loadPenInsulinRecords() {
        return getPenInfo({ uid: this.userId })
          .then(({ data }) => {
            const penInfo = data && data.data && data.data[0]
            const peizhi = penInfo && penInfo.peizhi ? JSON.parse(penInfo.peizhi) : {}
            this.insType = peizhi.insType
            this.insulinAgeMode = peizhi.insulinAgeMode || DEFAULT_INSULIN_AGE_MODE
            this.duration = getInsulinEffectDurationHours(this.insType, this.insulinAgeMode)
            const records = penInfo && penInfo.jilu
            this.insRecordList = Array.isArray(records) ? records : records ? JSON.parse(records) : []
            this.sortInsRecordList()
            this.actIobList = this.getIOBChartData()
            this.maxIob = this.actIobList.length ? Math.max(...this.actIobList.map(item => item.value)) : 0
          })
          .catch(() => {
            this.insRecordList = []
            this.actIobList = []
            this.maxIob = 0
          })
      },
      buildPenInsulinEvents() {
        const today = this.$moment().format('YYYY-MM-DD')
        return this.insRecordList
          .map(item => {
            const dose = Number(item.realInsulin)
            const sourceTime = this.$moment(item.createTime)
            if (!dose || !sourceTime.isValid() || sourceTime.format('YYYY-MM-DD') !== this.selectedDate) {
              return null
            }
            const createTime = today + ' ' + sourceTime.format('HH:mm:ss')
            return {
              createTime,
              create_time: createTime,
              sourceTime: sourceTime.format('YYYY-MM-DD HH:mm:ss'),
              tooltip_time: sourceTime.format('HH:mm'),
              type: 'Correction Bolus',
              eventType: 'Correction Bolus',
              insulin: dose.toFixed(2),
              insulinType:
                getInsulinTypeName(item.insulinType) === '--'
                  ? item.medicalType || '胰岛素笔'
                  : getInsulinTypeName(item.insulinType),
              notes: item.notes || '',
              v: 0,
            }
          })
          .filter(Boolean)
      },
      deduplicateData(data) {
        // 1. 复制并按时间戳升序排序
        const sortedData = [...data].sort((a, b) => new Date(a.create_time) - new Date(b.create_time))

        // 2. 用于记录某 insulin 值上一次出现的时间戳
        const lastOccurrence = {}

        // 3. 用于存放结果
        const result = []

        for (let item of sortedData) {
          const { create_time, insulin, type } = item

          // 如果没有 insulin 字段，直接保留
          if (type !== 'Correction Bolus') {
            result.push(item)
            continue
          }

          // 判断是否在 20 秒内重复
          if (lastOccurrence.hasOwnProperty(insulin) && new Date(create_time) - lastOccurrence[insulin] < 20 * 1000) {
            // 如果是 20 秒内出现相同 insulin，则跳过
            continue
          } else {
            // 否则保留该条数据并更新记录
            result.push(item)
            lastOccurrence[insulin] = new Date(create_time)
          }
        }
        return result
      },
      // websoket来信息调用
      getAllData() {
        if (this.mixPlot1) {
          this.mixPlot1.destroy()
          this.mixPlot1 = null
        }
        this.getData().then(() => {
          this.getAllEvent().then(() => {
            this.$nextTick(() => {
              this.getChart()
            })
          })
        })
      },
      // 血糖事件集合数组按照事件排序
      sortTime(obj) {
        obj.sort((a, b) => {
          let t1 = new Date(Date.parse(a.create_time.replace(/-/g, '/')))
          let t2 = new Date(Date.parse(b.create_time.replace(/-/g, '/')))
          return t1.getTime() - t2.getTime()
        })
        return obj
      },
      // 获取所有事件
      async getAllEvent() {
        await this.loadPenInsulinRecords()
        return new Promise(resolve => {
          const today = this.$moment().format('YYYY-MM-DD')
          this.eventArr = []
          // 获取基础率和临时基础率组合数组
          const tempParams = {
            uid: this.userId,
            end: this.selectedDate + ' 23:59:59',
            start: this.selectedDate + ' 00:00:00',
            type: this.loopRemote,
          }
          let params = {
            uid: this.userId,
            create_time: this.$moment().add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
            type: this.loopRemote,
          }
          loopHistory(params).then(res => {
            this.$emit('loopInfo', res)
          })

          getAllTempArry(tempParams).then(res => {
            // 基础率组合数组
            this.allTempArray = res ? (res.data.data.length ? res.data.data : []) : []
            this.maxTemp = Math.max(...this.allTempArray.map(item => item.value))
            this.allTempArray.forEach(item => {
              item.timestamp = today + ' ' + item.timestamp.substring(11, 16)
            })
            this.actIobList.forEach(item => {
              item.create_time = today + ' ' + item.create_time.substring(11, 16)
            })

            // 获取 ns 事件
            const nsParams = {
              uid: this.userId,
              end: this.selectedDate + ' 23:59:59',
              start: this.selectedDate + ' 00:00:00',
              type: this.loopRemote,
            }
            loopTreatments(nsParams).then(({ data }) => {
              data.treatments.forEach(item => {
                if (item.eventType === 'Temp Basal') {
                }
                // 胰岛素
                else if (item.eventType === 'Correction Bolus' || item.eventType === 'Meal Bolus') {
                  if (item.insulin) {
                    item.createTime = today + ' ' + item.create_time.substring(11, 16)
                    item.v = 0
                    item.type = 'Correction Bolus'
                    item.insulin = (item.insulin * 1).toFixed(2)
                    this.eventArr.push(item) // 添加ns事件---胰岛素
                  }
                } else if (item.eventType === 'Combo Bolus') {
                  if (item.enteredinsulin) {
                    item.createTime = item.create_time
                    item.v = 0
                    item.type = 'Combo Bolus'
                    item.insulin = (item.enteredinsulin * 1).toFixed(2)
                    this.eventArr.push(item) // 添加ns事件---胰岛素
                  }
                }
                // 碳水分组
                else if (item.eventType === 'Carb Correction') {
                  item.createTime = today + ' ' + item.create_time.substring(11, 16)
                  item.v = -1
                  item.type = item.eventType
                  this.eventArr.push(item) // 添加ns事件---碳水
                }
                // 覆盖方波分组
                else if (
                  this.loopRemote == 'loop'
                    ? item.eventType === 'Temporary Override' && item.duration
                    : item.eventType === 'Temporary Target'
                ) {
                  item.createTime = today + ' ' + item.create_time.substring(11, 16)
                  item.v = -2
                  item.type = 'Temporary Override'
                  item.duration = item.durationInMilliseconds
                    ? (item.durationInMilliseconds / 1000 / 60).toFixed(1)
                    : (item.duration * 1).toFixed(1)
                  this.eventArr.push(item) // 添加ns事件---覆盖方波
                }
                // 泵分组
                else if (
                  this.loopRemote == 'loop' ? item.eventType === 'Suspend Pump' : item.eventType === 'OpenAPS Offline'
                ) {
                  item.createTime = today + ' ' + item.create_time.substring(11, 16)
                  item.v = -2
                  item.type = 'Suspend Pump'
                  this.eventArr.push(item)
                }
                // 其他
                // else {
                //   item.createTime = item.create_time;
                //   item.v = -2;
                //   item.type = item.eventType;
                //   this.eventArr.push(item);
                // }
              })
              this.eventArr = this.deduplicateData(this.eventArr.concat(this.buildPenInsulinEvents()))

              this.eventArr.forEach(event => {
                event.create_time = event.createTime
                event.type = event.type
                event.tooltip_time = event.createTime.substring(11, 16)
                event.v = 1

                this.chartData.push(event)
              })
              this.sortTime(this.chartData)

              let v2 = ''
              let v1 = ''
              this.chartData.forEach((item, index) => {
                // 把时间、血糖合并数组里的血糖先挑出来处理
                if (item.type != 'sugar') {
                  if (item.type == 'Temporary Override') {
                    item.v = 18.5
                  } else {
                    for (let i = index - 1; i >= 0; i--) {
                      if (this.chartData[i].type == 'sugar') {
                        v1 = this.chartData[i].v
                        break
                      }
                    }

                    for (let i = index + 1; i <= this.chartData.length - 1; i++) {
                      if (this.chartData[i].type == 'sugar') {
                        v2 = this.chartData[i].v
                        break
                      }
                    }
                    if (v1 && v2) {
                      item.v = (v1 + v2) / 2
                    } else if (v1) {
                      item.v = v1
                    } else if (v2) {
                      item.v = v2
                    }
                  }
                }
                // 把每个点（包括事件，否则可能会图表错乱）都复值前一个基础率
                const time = this.$moment(item.create_time).valueOf()

                if (data.treatments && data.treatments.length) {
                  this.allTempArray.forEach((temp, i) => {
                    const preTime = this.$moment(temp.timestamp).valueOf()
                    const nextTime = this.allTempArray[i + 1]
                      ? this.$moment(this.allTempArray[i + 1].timestamp).valueOf()
                      : null
                    if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
                      item.tempValue = temp.value < 0 ? 0 : temp.value
                      item.tempType = temp.type
                    }
                  })
                }
                if (this.actIobList.length) {
                  this.actIobList.forEach((iob, i) => {
                    const preTime = this.$moment(iob.create_time).valueOf()
                    const nextTime = this.actIobList[i + 1]
                      ? this.$moment(this.actIobList[i + 1].create_time).valueOf()
                      : null
                    if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
                      item.iob = iob.value
                      item.iobType = iob.type
                    }
                  })
                }
              })
              // 获取糖仁云事件
              const params = {
                id: this.userId,
                end: this.selectedDate + ' 23:59:59',
                start: this.selectedDate + ' 00:00:00',
              }
              getEvent(params).then(({ data }) => {
                data.data.forEach(trEvent => {
                  if (trEvent.type === 'cx') {
                    const dose = Number(trEvent.way)
                    const createTime = trEvent.createTime
                    if (Number.isFinite(dose) && dose > 0 && createTime) {
                      const eventTime = this.$moment(createTime).valueOf()
                      const sugarList = this.chartData
                        .filter(item => item.type === 'sugar' && this.$moment(item.create_time).isValid())
                        .sort((a, b) => this.$moment(a.create_time).valueOf() - this.$moment(b.create_time).valueOf())
                      const prevSugar = [...sugarList]
                        .reverse()
                        .find(item => this.$moment(item.create_time).valueOf() <= eventTime)
                      const nextSugar = sugarList.find(item => this.$moment(item.create_time).valueOf() >= eventTime)
                      this.chartData.push({
                        ...trEvent,
                        createTime,
                        create_time: createTime,
                        tooltip_time: createTime.substring(11, 16),
                        type: 'Correction Bolus',
                        eventType: 'Correction Bolus',
                        insulin: dose.toFixed(2),
                        insulinType: '长效胰岛素',
                        notes: '',
                        isLongActingInsulin: true,
                        v:
                          prevSugar && nextSugar
                            ? (prevSugar.v + nextSugar.v) / 2
                            : prevSugar
                            ? prevSugar.v
                            : nextSugar
                            ? nextSugar.v
                            : 24,
                      })
                    }
                  } else {
                    trEvent.create_time = trEvent.createTime
                    trEvent.v = 24

                    this.chartData.push(trEvent)
                  }
                })
                // 获取生化 / 爱奥乐血压 / 爱奥乐血糖设备信息
                Promise.all([
                  getDeviceData({
                    uid: this.userId,
                  }),
                  getAolXueyaData({
                    uid: this.userId,
                  }),
                  getAolXuetangData({
                    uid: this.userId,
                  }),
                ])
                  .then(([deviceRes, aolXyRes, aolXtRes]) => {
                    const deviceDataList = this.filterDataByDate(deviceRes.data.data, this.selectedDate)
                    deviceDataList.forEach(item => {
                      if (item.content.type == 'BF') {
                        this.chartData.push({
                          create_time: today + ' ' + this.$moment(item.content.time * 1000).format('HH:mm:ss'),
                          type: item.content.type,
                          v:
                            item.content.type == 'GLU'
                              ? 19
                              : item.content.type == 'UA'
                              ? 21
                              : item.content.type == 'BF'
                              ? 23
                              : 25,
                          TC: item.content.TC,
                          TG: item.content.TG,
                          HDL: item.content.HDL,
                          LDL: item.content.LDL,
                        })
                      } else {
                        this.chartData.push({
                          create_time: today + ' ' + this.$moment(item.content.time * 1000).format('HH:mm:ss'),
                          type: item.content.type,
                          v:
                            item.content.type == 'GLU'
                              ? 19
                              : item.content.type == 'UA'
                              ? 21
                              : item.content.type == 'BF'
                              ? 23
                              : 25,
                          value: item.content.value,
                        })
                      }
                    })
                    this.formatAolXueyaChartData((aolXyRes.data && aolXyRes.data.data) || []).forEach(item => {
                      this.chartData.push(item)
                    })
                    this.formatAolXuetangChartData((aolXtRes.data && aolXtRes.data.data) || []).forEach(item => {
                      this.chartData.push(item)
                    })
                    this.fillChartDataIob()
                    this.sortTime(this.chartData)
                    resolve()
                  })
                  .catch(() => {
                    this.fillChartDataIob()
                    resolve()
                  })
              })
            })
          })
        })
      },
      getChart() {
        const box1 = this.$refs.container1
        if (!box1) return
        const data = this.chartData

        this.mixPlot1 = new Mix('container1', {
          appendPadding: 8,
          padding: [60, 20, 40, 20],
          syncViewPadding: true,
          data,
          tooltip: {
            showTitle: false,
            customContent: (title, data) => this.renderPointTooltip(title, data),
          },
          supportCSSTransform: true,

          plots: [
            {
              type: 'scatter',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'v',
                // size: this.chartTime == 0.875 ? 3 : this.chartTime == 0.75 || this.chartTime == 0.5 ? 2 : 1,
                shape: 'circle',
                pointStyle: {
                  stroke: null, // 移除边框
                  fillOpacity: 1, // 填充不透明
                },
                sizeField: 'type',
                size: ({ type }) => {
                  if (type != 'sugar') {
                    return 0
                  } else {
                    return 1
                  }
                },
                colorField: 'v',

                color: ({ v }) => {
                  return v > this.targetHigh
                    ? '#F4664A'
                    : v > this.targetLow
                    ? '#6395fa'
                    : v > 0
                    ? '#ffaa29'
                    : '#f8f8f8' // y 值大于 25 时颜色为红色，否则为蓝色
                },
                // 隐藏颜色控件图例
                legend: {
                  visible: false,
                },
                tooltip: {
                  showTitle: false,
                  customContent: (title, data) => this.renderPointTooltip(title, data),
                },
                supportCSSTransform: true,
                xAxis: {
                  // visible: false,
                  type: 'time',
                  max: this.maxTime,
                  min: this.minTime,
                  tickInterval: this.tickInterval,
                  mask: 'HH:mm', // 显示格式为小时:分钟
                },
                yAxis: {
                  line: null,
                  tickMethod: () => [0, 5, 10, 15, 20, 25],
                },
                label: {
                  offsetY: 0,
                  content: item => {
                    this.loopType = item.json ? JSON.parse(item.json).type : ''
                    if (item.type == 'kfy') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/kfytr.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'ts') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: 'https://i.postimg.cc/sxTXkccS/01.png',
                        },
                      })
                      return group
                    } else if (item.type == 'yds') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/loopYDS.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'yd') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: 'https://i.postimg.cc/rwxTWjrJ/image.png',
                        },
                      })
                      return group
                    } else if (item.type == 'zx') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/zxtr.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'xy' || item.type == 'aolXy') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodPress.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'xz') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodZhi.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'ns') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/niaosuan.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'GLU' || item.type == 'aolXt') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/xuetang.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'UA') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/niaosuan.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'BF') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodZhi.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'KET') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/xt.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'Correction Bolus') {
                      const group = new G.Group({})
                      let width = ''
                      let height = ''
                      let fontSize = ''
                      if (item.insulin < 1) {
                        width = 4
                        height = 4
                        fontSize = 5
                      } else if (item.insulin >= 1 && item.insulin <= 8) {
                        width = 4 + 1.4 * item.insulin
                        height = 4 + 1.4 * item.insulin
                        fontSize = 5 + 0.6 * item.insulin
                      } else if (item.insulin > 8) {
                        width = 4 + 1.4 * 8 + (item.insulin - 8) * 0.6
                        height = 4 + 1.4 * 8 + (item.insulin - 8) * 0.6
                        fontSize = 5 + 0.6 * 8 + item.insulin * 0.1
                      }
                      width = width * 0.86
                      height = height * 0.86
                      fontSize = fontSize * 0.86
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 2,
                          y: 16,
                          // width: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 10 : 12,
                          // height: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 10 : 12,
                          width: width,
                          height: height,
                          img: item.isLongActingInsulin ? require('@/static/pic/ydsns.png') : yds,
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 8,
                          y: 1 * item.insulin < 1 ? 18 : 1 * item.insulin < 6 ? 8 : 6,
                          // fontSize: this.chartTime == 0.875 || this.chartTime == 0.75 ? 8 : 6,
                          fontSize: fontSize,
                          text: (item.insulin * 1).toFixed(1) + 'U',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: 1 * item.insulin > 1 ? '#000' : '#424242',
                        },
                      })
                      const comboNote = item.notes !== 'null' ? item.notes : ''
                      if (comboNote) {
                        group.addShape({
                          type: 'text',
                          attrs: {
                            x: 8,
                            y: 1 * item.insulin < 1 ? 20 : 1 * item.insulin < 6 ? 10 : 10,
                            fontSize: fontSize,
                            text: comboNote,
                            textAlign: 'center',
                            textBaseline: 'bottom',
                            fill: '#000',
                          },
                        })
                      }
                      return group
                    } else if (item.type == 'Combo Bolus') {
                      const group = new G.Group({})
                      let width = ''
                      let height = ''
                      let fontSize = ''
                      if (item.insulin < 1) {
                        width = 4
                        height = 4
                        fontSize = 5
                      } else if (item.insulin >= 1 && item.insulin <= 8) {
                        width = 4 + 1.4 * item.insulin
                        height = 4 + 1.4 * item.insulin
                        fontSize = 5 + 0.6 * item.insulin
                      } else if (item.insulin > 8) {
                        width = 4 + 1.4 * 8 + (item.insulin - 8) * 0.6
                        height = 4 + 1.4 * 8 + (item.insulin - 8) * 0.6
                        fontSize = 5 + 0.6 * 8 + item.insulin * 0.1
                      }
                      width = width * 0.86
                      height = height * 0.86
                      fontSize = fontSize * 0.86
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 2,
                          y: 16,
                          // width: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 10 : 12,
                          // height: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 10 : 12,
                          width: width,
                          height: height,
                          img: item.isLongActingInsulin ? require('@/static/pic/ydsns.png') : yds,
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 8,
                          y: 1 * item.insulin < 1 ? 18 : 1 * item.insulin < 6 ? 8 : 6,
                          // fontSize: this.chartTime == 0.875 || this.chartTime == 0.75 ? 8 : 6,
                          fontSize: fontSize,
                          text: (item.insulin * 1).toFixed(1) + 'U',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: 1 * item.insulin > 1 ? '#000' : '#424242',
                        },
                      })
                      const comboNote = item.notes !== 'null' ? item.notes : ''
                      if (comboNote) {
                        group.addShape({
                          type: 'text',
                          attrs: {
                            x: 8,
                            y: 1 * item.insulin < 1 ? 20 : 1 * item.insulin < 6 ? 10 : 10,
                            fontSize: fontSize,
                            text: comboNote,
                            textAlign: 'center',
                            textBaseline: 'bottom',
                            fill: '#000',
                          },
                        })
                      }
                      return group
                    } else if (item.type == 'Carb Correction') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 5,
                          y: 19,
                          width: this.chartTime == 0 ? 6 : this.chartTime == 0.5 ? 7 : 8,
                          height: this.chartTime == 0 ? 6 : this.chartTime == 0.5 ? 7 : 8,
                          img: require('@/static/pic/tstr.png'),
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 9,
                          y: 25,
                          fontSize: 6,
                          text: item.carbs + 'g',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: '#424242',
                        },
                      })
                      return group
                    } else if (item.type == 'Temporary Override') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: ((item.duration / 4) * 3) / 2,
                          y: 12,
                          width: (item.duration / 4) * 3,
                          height: 12,
                          img: require('@/static/pic/override.png'),
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: ((item.duration / 4) * 3) / 2 + 18,
                          y: 12,
                          fontSize: 8,
                          text: item.reason,
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: '#000',
                        },
                      })
                      return group
                    }
                    // else if (item.type == 'Suspend Pump') {
                    //   const group = new G.Group({})
                    //   group.addShape({
                    //     type: 'image',
                    //     attrs: {
                    //       x: 0,
                    //       y: 10,
                    //       width: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 11 : 13,
                    //       height: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 11 : 13,
                    //       img: require('@/static/pic/pump.png'),
                    //     },
                    //   })
                    //   return group
                    // }
                  },
                  labelLine: true,
                },
                annotations: [
                  {
                    type: 'region',
                    start: ['min', this.targetLow],
                    end: ['max', this.targetHigh],
                    style: {
                      stroke: '#edf0f2',
                      lineDash: [2, 2],
                    },
                  },

                  {
                    type: 'text',
                    position: ['min', this.targetHigh],
                    content: this.targetHigh,
                    style: {
                      fill: '#F4664A',
                    },
                  },

                  {
                    type: 'text',
                    position: ['min', this.targetLow],
                    content: this.targetLow,
                    style: {
                      fill: '#ffaa29',
                    },
                  },
                  // {
                  //   type: 'regionFilter',
                  //   start: ['min', 0],
                  //   end: ['max', 3.9],
                  //   color: '#ffaa29',
                  // },
                  // {
                  //   type: 'regionFilter',
                  //   start: ['min', 10],
                  //   end: ['max', 20],
                  //   color: '#F4664A',
                  // },
                ],
              },
            },
            {
              type: 'line',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'tempValue',
                stepType: 'vh',
                connectNulls: true,
                lineStyle: {
                  lineWidth: 1,
                },
                tooltip: {
                  showTitle: false,
                  crosshairs: {
                    type: 'x',
                    follow: true,
                  },
                  interactions: [{ type: 'tooltip' }],
                  position: 'top',
                  customContent: (title, data) => {
                    let loopType = title ? (data[0].data.json ? JSON.parse(data[0].data.json).type : '') : ''
                    let type = ''
                    let eventType = title ? data[0].data.type : ''
                    let res = title ? data[0].data : ''
                    let parse = title ? (data[0].data.json ? JSON.parse(data[0].data.json) : '') : ''
                    if (title && data[0].data.type === 'zx') {
                      type = '指尖血'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 场景：${res.eventValue}</div>` : ''}
                        <div style="margin-bottom:4px;">指血指数：${res.way}mmol/L</div>
                      </div>`
                    } else if (title && data[0].data.type === 'kfy') {
                      type = '口服药'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 药名：${res.way}</div>
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 用药量：${res.eventValue}mg</div>` : ''}
                      </div>`
                    } else if (title && data[0].data.type === 'aolXy') {
                      type = '爱奥乐血压'
                      const heartRate = res.data3
                        ? `<div style="margin-bottom:4px;font-size:12px;"> 心率：${res.data3}次/分</div>`
                        : ''
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px"> ${title}</div>
                        <div style="margin-bottom:4px;"> 高压：${res.data1 || '--'}mmHg</div>
                        <div style="margin-bottom:4px;"> 低压：${res.data2 || '--'}mmHg</div>
                        ${heartRate}
                      </div>`
                    } else if (title && data[0].data.type === 'xy') {
                      type = '血压'
                      const heartRate =
                        res.scene && res.scene !== '--'
                          ? `<div style="margin-bottom:4px;font-size:12px;"> 心率：${res.scene}次/分</div>`
                          : ''
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px"> ${title}</div>
                        <div style="margin-bottom:4px;"> 收缩压：${res.way || '--'}mmHg</div>
                        <div style="margin-bottom:4px;"> 舒张压：${res.eventValue || '--'}mmHg</div>
                        ${heartRate}
                      </div>`
                    } else if (title && data[0].data.type === 'xz') {
                      type = '血脂'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 总胆固醇：${res.way || '--'}mmol/L</div>
                        <div style="margin-bottom:4px;"> 甘油三酯：${res.eventValue || '--'}mmol/L</div>
                        <div style="margin-bottom:4px;"> 低密度脂蛋白：${res.scene || '--'}mmol/L</div>
                      </div>`
                    } else if (title && data[0].data.type === 'ns') {
                      type = '尿酸'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 尿酸值：${res.way || '--'}umol/L</div>
                      </div>`
                    } else if (title && data[0].data.type === 'aolXt') {
                      type = '爱奥乐血糖'
                      return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 血糖值：${res.value || '--'}mmol/L</div>
                        </div>`
                    } else if (title && data[0].data.type === 'GLU') {
                      type = '血糖'
                      return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 血糖值：${res.value || '--'}mmol/L</div>
                        </div>`
                    } else if (title && data[0].data.type === 'UA') {
                      type = '尿酸'
                      return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 尿酸值：${res.value || '--'}umol/L</div>
                        </div>`
                    } else if (title && data[0].data.type === 'KET') {
                      type = '血酮'
                      return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 血酮值：${res.value || '--'}mmol/L</div>
                        </div>`
                    } else if (title && data[0].data.type === 'BF') {
                      type = '血脂'
                      return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 总胆TC：${res.TC || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 甘油TG：${res.TG || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 高密HDL：${res.HDL || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 低密LDL：${res.LDL || '--'}mmol/L</div>
                        </div>`
                    } else if (title && data[0].data.type === 'ts') {
                      type = '碳水'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> ${res.eventValue}</div>
                        <div style="margin-bottom:4px;"> 碳水化合物：${res.way}g</div>
                      </div>`
                    } else if (title && data[0].data.type === 'yds') {
                      type = '胰岛素'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 注射剂量：${res.way}U</div>
                        ${res.scene ? `<div style="margin-bottom:4px;"> 注射时段：${res.scene}</div>` : ''}
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 胰岛素名称：${res.eventValue}</div>` : ''}
                      </div>`
                    } else if (title && data[0].data.type === 'yd') {
                      type = '运动'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 运动项目：${res.way}</div>
                        ${res.scene ? `<div style="margin-bottom:4px;"> 运动时长：${res.scene}分钟</div>` : ''}
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 消耗：${res.eventValue}kcal</div>` : ''}
                      </div>`
                    } else if (title && loopType == 1) {
                      type = '关闭闭环'
                    } else if (title && loopType == 2) {
                      type = '开启闭环'
                    } else if (title && loopType == 3) {
                      type = '覆盖方波'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 持续时间：${parse.minutes}</div>
                        <div style="margin-bottom:4px;"> 原因：${parse.fugainame}</div>
                      </div>`
                    } else if (title && loopType == 4) {
                      type = '取消方波'
                    } else if (title && loopType == 5) {
                      type = '添加碳水'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 总量：${parse.carbs}g</div>
                        <div style="margin-bottom:4px;"> 吸收时间：${parse.carbsHouers}h</div>
                      </div>`
                    } else if (title && loopType == 6) {
                      type = '大剂量'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 剂量：${parse.bolus}U</div>
                      </div>`
                    } else if (title && loopType == 7) {
                      type = '临时基础率'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 临时基础率：${parse.perHour}U/h</div>
                        <div style="margin-bottom:4px;"> 持续时间：${parse.baseHouers}h</div>
                      </div>`
                    } else if (title && loopType == 8) {
                      type = '取消临时'
                    } else if (title && eventType == 'Correction Bolus') {
                      type = '胰岛素'
                      return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量：${res.insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 名称：${res.insulinType || '无'}</div>
                      </div>`
                    } else if (title && eventType == 'Combo Bolus') {
                      type = '扩展胰岛素'
                      return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量：${res.insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 持续时间：${res.duration || '无'}分钟</div>
                      </div>`
                    } else if (title && eventType == 'Carb Correction') {
                      type = '碳水'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 克数：${res.carbs ? res.carbs + 'g' : '无'}</div>
                        <div style="margin-bottom:4px;"> 类型：${res.foodType ? res.foodType : '无'}</div>
                      </div>`
                    } else if (title && eventType == 'Temporary Override') {
                      type = '覆盖方波'
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 需求比例：${
                          res.insulinNeedsScaleFactor ? res.insulinNeedsScaleFactor : '无'
                        }</div>
                        <div style="margin-bottom:4px;"> 持续时间：${res.duration}分钟</div>
                        <div style="margin-bottom:4px;"> 原因：${res.reason}</div>
                      </div>`
                    } else if (title && eventType == 'Suspend Pump') {
                      type = '泵'
                    } else if (title && eventType == 'sugar') {
                      type = '血糖'
                      return `<div style="padding:2px;">
                        <div style="margin-bottom:2px;font-size:10px;font-weight: 700;"> ${title}</div>
                        <div style="font-size:10px;margin-bottom:2px;">${type}:${(data[0].data.v * 1).toFixed(1)}</div>
                        <div style="margin-bottom:2px;font-size:10px"> 基础率:${
                          data[0].data.tempValue == 0 ? 0 : data[0].data.tempValue || '无'
                        }</div>
                        <div style="font-size:10px;margin-bottom:2px;">\u6d3b\u6027\u80f0\u5c9b\u7d20:${
                          data[0].data.iob ? (data[0].data.iob <= 0.04 ? 0 : data[0].data.iob) : 0
                        }</div>
                      </div>`
                    } else {
                      type = '其他'
                    }
                    return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div> ${title}</div>
                      </div>`
                  },
                },
                xAxis: {
                  // visible: false,
                  type: 'time',
                  max: this.maxTime,
                  min: this.minTime,
                  tickInterval: this.tickInterval,
                  mask: 'HH:mm', // 显示格式为小时:分钟
                  tickMethod: scale => {
                    let { min, max, tickCount } = scale
                    const time = this.maxTime.substring(11, 13)
                    let tickInterval = ''
                    if (this.isToday) {
                      if (time <= 3) {
                        tickInterval = 1000 * 60 * 30
                      } else if (time <= 7) {
                        tickInterval = 1000 * 60 * 60
                      } else if (time <= 18) {
                        const next = this.$moment(this.maxTime).add(1, 'hours').format('YYYY-MM-DD HH:00:00')
                        max = time % 2 ? new Date(next).valueOf() : max
                        tickInterval = 1000 * 60 * 60 * 2
                      } else if (time <= 24) {
                        const last = this.$moment().add(1, 'days').format('YYYY-MM-DD 00:00:00').valueOf()
                        max = new Date(last).valueOf()
                        tickInterval = 1000 * 60 * 60 * 3
                      }
                    } else {
                      tickInterval = 1000 * 60 * 60 * 3
                    }
                    const ticks = []
                    for (let i = min; i <= max; i += tickInterval) {
                      ticks.push(i)
                    }
                    return ticks
                  },
                },
                yAxis: {
                  min: 0,
                  max: this.maxTemp * 5.6,
                  label: null,
                  grid: null,
                  // tickMethod: () => [ 1, 2, 3],
                },
              },
            },
            {
              type: 'line',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'iob',
                color: '#009944',
                connectNulls: true,
                lineStyle: {
                  lineWidth: 0,
                },
                area: {
                  smooth: true,
                  style: {
                    fill: '#1890ff',
                    fillOpacity: 0.3,
                  },
                },
                tooltip: {
                  showTitle: false,
                  customContent: (title, data) => this.renderPointTooltip(title, data),
                },
                xAxis: {
                  type: 'time',
                  max: this.maxTime,
                  min: this.minTime,
                  tickInterval: this.tickInterval,
                  mask: 'HH:mm',
                },
                yAxis: {
                  min: 0,
                  max: this.maxIob ? this.maxIob * 4 : 4,
                  label: null,
                  grid: null,
                },
              },
            },
          ],
          xAxis: {
            // visible: false,
            type: 'time',
            max: this.maxTime,
            min: this.minTime,
            tickInterval: this.tickInterval,
            mask: 'HH:mm', // 显示格式为小时:分钟
          },
        })
        this.mixPlot1.render()

        // 点击/触摸开始：当前最近点策略（x、y综合）
        const showNearestTooltip = event => {
          const { x, y } = event
          // 获取点图中的所有数据点
          const elements = this.mixPlot1.chart.geometries[0].elements
          let closestElement = null
          let minDistance = Infinity

          elements.forEach(element => {
            const bbox = element.shape.getCanvasBBox()
            const elementX = (bbox.minX + bbox.maxX) / 2
            const elementY = (bbox.minY + bbox.maxY) / 2
            const distance = Math.hypot(x - elementX, y - elementY)

            if (distance < minDistance) {
              minDistance = distance
              closestElement = element
            }
          })

          if (closestElement) {
            const bbox = closestElement.shape.getCanvasBBox()
            this.mixPlot1.chart.showTooltip({
              x: (bbox.minX + bbox.maxX) / 2,
              y: (bbox.minY + bbox.maxY) / 2,
            })
          } else {
            this.mixPlot1.chart.hideTooltip()
          }
        }

        // 移动时：使用仅按 x 距离最近的点（原有逻辑）
        this.mixPlot1.on('plot:touchmove', event => {
          const { x } = event
          const elements = this.mixPlot1.chart.geometries[0].elements
          let closestElement = null
          let minDistance = Infinity

          elements.forEach(element => {
            const bbox = element.shape.getCanvasBBox()
            const elementX = (bbox.minX + bbox.maxX) / 2
            const distance = Math.abs(x - elementX)

            if (distance < minDistance) {
              minDistance = distance
              closestElement = element
            }
          })

          if (closestElement) {
            const bbox = closestElement.shape.getCanvasBBox()
            this.mixPlot1.chart.showTooltip({
              x: (bbox.minX + bbox.maxX) / 2,
              y: (bbox.minY + bbox.maxY) / 2,
            })
          } else {
            this.mixPlot1.chart.hideTooltip()
          }
        })
        this.mixPlot1.on('plot:touchstart', showNearestTooltip)
        this.mixPlot1.on('plot:click', showNearestTooltip)

        // 确保触摸移出图表时隐藏 tooltip
        this.mixPlot1.on('plot:touchend', () => {
          this.mixPlot1.chart.hideTooltip()
        })
      },

      getData() {
        return new Promise(resolve => {
          this.chartData = []
          const params = {
            id: this.userId,
            end: this.selectedDate + ' 23:59:59',
            start: this.selectedDate + ' 00:00:00',
          }

          getSugerbyId(params).then(res => {
            const today = this.$moment().format('YYYY-MM-DD')
            if (res.data.data && res.data.data.length) {
              res.data.data.forEach(item => {
                this.chartData.push({
                  create_time: today + ' ' + item.create_time.substring(11, 16),
                  v: item.v,
                  tooltip_time: item.create_time.substring(11, 16),
                  type: 'sugar',
                })
              })
            }

            resolve()
          })
        })
      },
      // 退出全屏
      outFull() {
        this.$store.commit('changeLand')
        document.querySelector('#container1').style.height = 310 + 'px'
        this.chartHeight = this.$store.state.isLandscape ? window.innerWidth - 40 : 310
      },
      // 进入全屏
      inFull() {
        this.$store.commit('changeLand')
        const nowWidth = window.screen.width
        document.querySelector('#container1').style.height = nowWidth - 100 + 'px'
        this.chartHeight = this.$store.state.isLandscape ? window.innerWidth - 40 : 310
      },
    },

    computed: {
      minTime() {
        return this.$moment().format('YYYY-MM-DD 00:00:00')
      },
      maxTime() {
        const max = this.isToday
          ? this.$moment().add(1, 'hours').format('YYYY-MM-DD HH:00:00')
          : this.$moment().add(1, 'days').format('YYYY-MM-DD 00:00:00')
        return max
      },
    },

    watch: {
      selectedDate: {
        handler: function (newVal, oldVal) {
          this.$nextTick(() => {
            this.isToday = newVal === this.$moment().format('YYYY-MM-DD')
            if (this.$route.query.id) {
              this.getDateById()
            } else {
              if (this.mixPlot1) {
                this.mixPlot1.destroy()
                this.mixPlot1 = null
              }
              this.getAllData()
            }
          })
        },
      },
    },
  }
</script>

<style scoped lang="less">
  .common-box {
    width: 96%;
    border-radius: 1.2rem;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 2px 0px rgba(6, 14, 33, 0.16);
    position: relative;
    margin-left: 2%;
    margin-bottom: 8px;
  }
  .common-title {
    position: absolute;
    top: 0;
    width: 97%;
    height: 3.4rem;
    font-size: 1.4rem;
    font-weight: 700;
    text-align: start;
    line-height: 3.4rem;
    /* border-bottom: 1px solid #ccc; */
    padding-left: 1rem;
    background: aliceblue;
  }
  .handleShow {
    position: absolute;
    right: 1rem;
    top: 0.4rem;
    width: 30px;
    height: 30px;
    z-index: 99999;
  }
  .handleShow img {
    width: 25px;
    height: 25px;
  }
  .shuiping {
    width: 100vh;
    height: 100vw;
    border-radius: 0;
    /* box-shadow: 0; */
    position: absolute;
    top: 50%;
    left: 48%;
    transform: translate(-50%, -50%) rotate(90deg);
    z-index: 9999;
    /* 阻止屏幕拖动 */
    overflow: hidden;
    touch-action: none;
  }
</style>
